import { render, staticRenderFns } from "./EditMemberView.vue?vue&type=template&id=224a4a04&"
import script from "./EditMemberView.vue?vue&type=script&lang=js&"
export * from "./EditMemberView.vue?vue&type=script&lang=js&"
import style0 from "./EditMemberView.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports